import { render, staticRenderFns } from "./logProfessionalDevelopment.vue?vue&type=template&id=97dc0c7c&"
import script from "./logProfessionalDevelopment.vue?vue&type=script&lang=js&"
export * from "./logProfessionalDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports